import { Text } from '../../constants/TextConstants'

export const BaseRolesConstant = {
  Admin: Text.AdminTooltipText,
  Manager: Text.ManagerTooltipText,
  'Head Of Discipline': Text.HeadOfDisciplineTooltipText,
  Lead: Text.LeadTooltipText,
  Endavan: Text.EndavanTooltipText
}
